import { render, staticRenderFns } from "./DialogDeleteTreinamentoProfessorComponent.vue?vue&type=template&id=2a99fe1a&"
import script from "./DialogDeleteTreinamentoProfessorComponent.vue?vue&type=script&lang=js&"
export * from "./DialogDeleteTreinamentoProfessorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports